// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__WJ3es","notes":"Notes_notes__Q60CV"};